import {
  ColoredConsoleStrategy,
  LoggerService as FluxLoggerService,
  LocalStorageAdapter,
} from '@flux/logger';

FluxLoggerService.setStrategy(new ColoredConsoleStrategy());
FluxLoggerService.setAdapter(new LocalStorageAdapter());

export const fluxLogger = FluxLoggerService.create('flux');
